import { EPages } from '@microfrontends/app-shell-v2'
import { ELanguage } from '@microfrontends/react-components'
import MainLayout from '../../containers/MainLayout'
import RecommendedJobsContainer from '../../containers/RecommendedJobsContainer'
import { withTranslation } from '../../i18n'
import { withAuthSync } from '../../services/auth/auth'
import IPageProps from '../../services/models'

export function RecommendedJobs(props: IPageProps) {
	return (
		<MainLayout
			{...props}
			pageName={EPages.RECOMMENDED_JOBS}
			languageCode={ELanguage.VI}
			responsiveCornerColor='#f9f9f9'
		>
			<RecommendedJobsContainer userIP={props.userIP} />
		</MainLayout>
	)
}

export default withTranslation('home')(withAuthSync(RecommendedJobs))
